import ScratchBlocks from 'scratch-blocks';

const categorySeparator = '<sep gap="36"/>';

const blockSeparator = '<sep gap="36"/>'; // At default scale, about 28px

const motion = function (isStage, targetId) {
    const stageSelected = ScratchBlocks.ScratchMsgs.translate(
        'MOTION_STAGE_SELECTED',
        'Stage selected: no motion blocks'
    );
    return `
    <category name="%{BKY_CATEGORY_MOTION}" id="motion" colour="#4C97FF" secondaryColour="#3373CC">
        ${isStage ? `
        <label text="${stageSelected}"></label>
        ` : `
        <block type="motion_movesteps">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="STEPS">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="motion_turnright">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="DEGREES">
                <shadow type="text">
                    <field name="TEXT">15</field>
                </shadow>
            </value>
        </block>
        <block type="motion_turnleft">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="DEGREES">
                <shadow type="text">
                    <field name="TEXT">15</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_goto">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="TO">
                <shadow type="motion_goto_menu">
                </shadow>
            </value>
        </block>
        <block type="motion_gotoxy">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="X">
                <shadow id="movex" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="Y">
                <shadow id="movey" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="motion_glideto" id="motion_glideto">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="TO">
                <shadow type="motion_glideto_menu">
                </shadow>
            </value>
        </block>
        <block type="motion_glidesecstoxy">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="X">
                <shadow id="glidex" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="Y">
                <shadow id="glidey" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_pointindirection">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="DIRECTION">
                <shadow type="math_angle">
                    <field name="NUM">90</field>
                </shadow>
            </value>
        </block>
        <block type="motion_pointtowards">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="TOWARDS">
                <shadow type="motion_pointtowards_menu">
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_changexby">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="DX">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="motion_setx">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="X">
                <shadow id="setx" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="motion_changeyby">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="DY">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="motion_sety">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="Y">
                <shadow id="sety" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_ifonedgebounce">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="motion_setrotationstyle">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
        </block>
        ${blockSeparator}
        <block id="${targetId}_xposition" type="motion_xposition">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
        </block>
        <block id="${targetId}_yposition" type="motion_yposition">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
        </block>
        <block id="${targetId}_direction" type="motion_direction">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
        </block>`}
        ${categorySeparator}
    </category>
    `;
};

const xmlEscape = function (unsafe) {
    return unsafe.replace(/[<>&'"]/g, c => {
        switch (c) {
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '&': return '&amp;';
        case '\'': return '&apos;';
        case '"': return '&quot;';
        }
    });
};

const looks = function (isStage, targetId, costumeName, backdropName) {
    const hello = ScratchBlocks.ScratchMsgs.translate('LOOKS_HELLO', 'Hello!');
    const hmm = ScratchBlocks.ScratchMsgs.translate('LOOKS_HMM', 'Hmm...');
    return `
    <category name="%{BKY_CATEGORY_LOOKS}" id="looks" colour="#9966FF" secondaryColour="#774DCB">
        ${isStage ? '' : `
        <block type="looks_sayforsecs">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hello}</field>
                </shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">2</field>
                </shadow>
            </value>
        </block>
        <block type="looks_say">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hello}</field>
                </shadow>
            </value>
        </block>
        <block type="looks_thinkforsecs">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hmm}</field>
                </shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">2</field>
                </shadow>
            </value>
        </block>
        <block type="looks_think">
            <value name="TARGET">
                <shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
            </value>
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hmm}</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        `}
        ${isStage ? `
            <block type="looks_switchbackdropto">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_switchbackdroptoandwait">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextbackdrop"/>
        ` : `
            <block id="${targetId}_switchcostumeto" type="looks_switchcostumeto">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
                <value name="COSTUME">
                    <shadow type="looks_costume">
                        <field name="COSTUME">${costumeName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextcostume">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
            </block>
            <block type="looks_switchbackdropto">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextbackdrop"/>
            ${blockSeparator}
            <block type="looks_changesizeby">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
                <value name="CHANGE">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_setsizeto">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
                <value name="SIZE">
                    <shadow type="math_number">
                        <field name="NUM">100</field>
                    </shadow>
                </value>
            </block>
        `}
        ${blockSeparator}
        <block type="looks_changeeffectby">
	    <value name="TARGET">
		<shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
	    </value>
            <value name="CHANGE">
                <shadow type="math_number">
                    <field name="NUM">25</field>
                </shadow>
            </value>
        </block>
        <block type="looks_seteffectto">
	    <value name="TARGET">
		<shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
	    </value>
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="looks_cleargraphiceffects">
	    <value name="TARGET">
		<shadow type="esterel_sprite">
		    <value name="TARGET">
			<shadow type="esterel_target_menu"/>
		    </value>
		</shadow>
	    </value>
        </block>
        ${blockSeparator}
        ${isStage ? '' : `
            <block type="looks_show">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
	    </block>
            <block type="looks_hide">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
	    </block>
        ${blockSeparator}
            <block type="looks_gotofrontback">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
	    </block>
            <block type="looks_goforwardbackwardlayers">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
                <value name="NUM">
                    <shadow type="math_integer">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
            </block>
        `}
        ${isStage ? `
            <block id="backdropnumbername" type="looks_backdropnumbername"/>
        ` : `
            <block id="${targetId}_costumenumbername" type="looks_costumenumbername">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
            </block>
            <block id="backdropnumbername" type="looks_backdropnumbername"/>
            <block id="${targetId}_size" type="looks_size">
		<value name="TARGET">
		    <shadow type="esterel_sprite">
			<value name="TARGET">
			    <shadow type="esterel_target_menu"/>
			</value>
		    </shadow>
		</value>
            </block>
        `}
        ${categorySeparator}
    </category>
    `;
};

const sound = function (isStage, targetId, soundName) {
    return `
    <category name="%{BKY_CATEGORY_SOUND}" id="sound" colour="#D65CD6" secondaryColour="#BD42BD">
        <block id="${targetId}_sound_playuntildone" type="sound_playuntildone">
            <value name="SOUND_MENU">
                <shadow type="sound_sounds_menu">
                    <field name="SOUND_MENU">${soundName}</field>
                </shadow>
            </value>
        </block>
        <block id="${targetId}_sound_play" type="sound_play">
            <value name="SOUND_MENU">
                <shadow type="sound_sounds_menu">
                    <field name="SOUND_MENU">${soundName}</field>
                </shadow>
            </value>
        </block>
        <block type="sound_stopallsounds"/>
        ${blockSeparator}
        <block type="sound_changeeffectby">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="sound_seteffectto">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
        <block type="sound_cleareffects"/>
        ${blockSeparator}
        <block type="sound_changevolumeby">
            <value name="VOLUME">
                <shadow type="math_number">
                    <field name="NUM">-10</field>
                </shadow>
            </value>
        </block>
        <block type="sound_setvolumeto">
            <value name="VOLUME">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
        <block id="${targetId}_volume" type="sound_volume"/>
        ${categorySeparator}
    </category>
    `;
};

const events = function (isStage) {
    return `
    <category name="%{BKY_CATEGORY_EVENTS}" id="events" colour="#FFD500" secondaryColour="#CC9900">
        <block type="esterel_signal">
	    <value name="SIGNAL">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
        <block type="esterel_emit">
            <value name="SIGNAL">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
	<block type="esterel_signal_present">
            <value name="SIGNAL">
		<shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	</block>
	<block type="esterel_signal_was_present">
            <value name="SIGNAL">
		<shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	</block>
	<block type="esterel_immediate" />
	<block type="esterel_counter">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
	</block>
        ${blockSeparator}
        <block type="esterel_tick"/>
        ${blockSeparator}
        <block type="esterel_valued_signal">
	    <value name="SIGNAL">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	    <value name="EXPR">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	    <value name="TYPE">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	    <value name="COMBINE">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
        <block type="esterel_valued_emit">
            <value name="SIGNAL">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
            <value name="EXPR">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
	<block type="esterel_value_of_signal">
            <value name="SIGNAL">
		<shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	</block>
	<block type="esterel_previous_value_of_signal">
            <value name="SIGNAL">
		<shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	</block>
        ${blockSeparator}
        <block type="esterel_await" />
        <block type="esterel_await_ai" />
        <block type="esterel_await_acs" />
        <block type="esterel_case" />
        ${blockSeparator}
        <block type="esterel_sustain">
            <value name="SIGNAL">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
        <block type="esterel_valued_sustain">
            <value name="SIGNAL">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
            <value name="EXPR">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const control = function (isStage) {
    return `
    <category name="%{BKY_CATEGORY_CONTROL}" id="control" colour="#FFAB19" secondaryColour="#CF8B17">
        <block type="esterel_whenflagclicked"/>
        <block id="pause" type="esterel_pause"/>
        <block id="loop" type="esterel_loop"/>
        <block id="par" type="esterel_par"/>
        <block type="esterel_if"/>
        <block type="esterel_clone">
            <value name="TARGET">
                <shadow type="esterel_target_menu"/>
            </value>
            <value name="VAR">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	</block>
        <block type="esterel_for_each_clone">
            <value name="VAR">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
            <value name="TARGET">
                <shadow type="esterel_target_menu"/>
            </value>
	</block>
        ${blockSeparator}
        <block type="esterel_wait">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM">3</field>
                </shadow>
            </value>
	</block>
        <block type="esterel_halt"/>
        <block type="esterel_repeat">
	    <value name="EXPR">
                <shadow type="math_whole_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
	</block>
        <block type="esterel_positive_repeat">
	    <value name="EXPR">
                <shadow type="math_whole_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
	</block>
        <block type="esterel_loop_each" />
        <block type="esterel_if_without_else"/>
        ${categorySeparator}
    </category>
    `;
};

const preemption = function (isStage) {
    return `
    <category name="%{BKY_CATEGORY_PREEMPTION}" id="preemption" colour="#FF6680" secondaryColour="#FF4D6A">
        <block type="esterel_trap">
            <value name="TRAP">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
        <block type="esterel_exit">
            <value name="TRAP">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
        <block type="esterel_suspend" />
        ${blockSeparator}
        <block type="esterel_valued_trap">
	    <value name="TRAP">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	    <value name="EXPR">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	    <value name="TYPE">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	    <value name="COMBINE">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
        <block type="esterel_valued_exit">
            <value name="TRAP">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
            <value name="EXPR">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
	<block type="esterel_value_of_trap">
            <value name="TRAP">
		<shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	</block>
        ${blockSeparator}
        <block type="esterel_trap_with_handles">
            <value name="TRAP">
                <shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
        </block>
        <block type="esterel_trap_raised">
            <value name="TRAP">
		<shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	</block>
        <block type="esterel_handle" />
        <block type="esterel_abort" />
        <block type="esterel_abort_ai" />
        <block type="esterel_abort_acs" />
        <block type="esterel_weak_abort" />
        <block type="esterel_weak_abort_ai" />
        <block type="esterel_weak_abort_acs" />
        ${categorySeparator}
    </category>
    `;
};

const variables = function () {
    return `
    <category name="%{BKY_CATEGORY_VARIABLES}" id="variables" colour="#FF8C1A" secondaryColour="#DB6E00">
        <block type="esterel_sprite">
            <value name="TARGET">
                <shadow type="esterel_target_menu"/>
            </value>
        </block>
        <block type="esterel_var_without_init">
            <value name="VAR">
		<shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
        </block>
        <block type="esterel_var_with_init">
            <value name="VAR">
		<shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
	    <value name="EXPR">
		<shadow type="text">
                    <field name="TEXT">0</field>
                </shadow>
	    </value>
        </block>
        <block type="esterel_shared">
            <value name="SHARED">
		<shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
	    <value name="EXPR">
		<shadow type="text">
                    <field name="TEXT">0</field>
                </shadow>
	    </value>
            <value name="COMBINE">
		<shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
        </block>
        <block type="esterel_assign_var">
            <value name="VAR">
		<shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
	    <value name="EXPR">
		<shadow type="text">
                    <field name="TEXT">0</field>
                </shadow>
	    </value>
        </block>
        <block type="esterel_assign_shared">
            <value name="SHARED">
		<shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
	    <value name="EXPR">
		<shadow type="text">
                    <field name="TEXT">0</field>
                </shadow>
	    </value>
        </block>
	<block type="esterel_value_of_data">
            <value name="DATA">
		<shadow type="text">
                    <field name="TEXT"> </field>
                </shadow>
            </value>
	</block>
        ${blockSeparator}
        <block type="esterel_boolean" />
        <block type="esterel_natural" />
        <block type="esterel_integer" />
        <block type="esterel_rational" />
        <block type="esterel_string" />
        <block type="esterel_list" />
        <block type="esterel_float" />
    </category>
    `;
};

const sensing = function (isStage) {
    const name = ScratchBlocks.ScratchMsgs.translate('SENSING_ASK_TEXT', 'What\'s your name?');
    return `
    <category name="%{BKY_CATEGORY_SENSING}" id="sensing" colour="#4CBFE6" secondaryColour="#2E8EB8">
        ${isStage ? '' : `
            <block type="sensing_touchingobject">
		<value name="TARGET">
		    <shadow type="esterel_target_menu"/>
		</value>
                <value name="TOUCHINGOBJECTMENU">
                    <shadow type="sensing_touchingobjectmenu"/>
                </value>
            </block>
            <block type="sensing_touchingcolor">
		<value name="TARGET">
		    <shadow type="esterel_target_menu"/>
		</value>
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
            </block>
            <block type="sensing_coloristouchingcolor">
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
                <value name="COLOR2">
                    <shadow type="colour_picker"/>
                </value>
            </block>
            <block type="sensing_distanceto">
		<value name="TARGET">
		    <shadow type="esterel_target_menu"/>
		</value>
                <value name="DISTANCETOMENU">
                    <shadow type="sensing_distancetomenu"/>
                </value>
            </block>
            ${blockSeparator}
        `}
        <block id="askandwait" type="sensing_askandwait">
            <value name="QUESTION">
                <shadow type="text">
                    <field name="TEXT">${name}</field>
                </shadow>
            </value>
        </block>
        <block id="answer" type="sensing_answer"/>
        ${blockSeparator}
        <block type="sensing_keypressed">
            <value name="KEY_OPTION">
                <shadow type="sensing_keyoptions"/>
            </value>
        </block>
        <block type="sensing_mousedown"/>
        <block type="sensing_mousex"/>
        <block type="sensing_mousey"/>
        ${categorySeparator}
    </category>
    `;
};

const operators = function () {
    const apple = ScratchBlocks.ScratchMsgs.translate('OPERATORS_JOIN_APPLE', 'apple');
    const banana = ScratchBlocks.ScratchMsgs.translate('OPERATORS_JOIN_BANANA', 'banana');
    const letter = ScratchBlocks.ScratchMsgs.translate('OPERATORS_LETTEROF_APPLE', 'a');
    return `
    <category name="%{BKY_CATEGORY_OPERATORS}" id="operators" colour="#40BF4A" secondaryColour="#389438">
        <block type="operator_add">
            <value name="NUM1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
        </block>
        <block type="operator_subtract">
            <value name="NUM1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
        </block>
        <block type="operator_multiply">
            <value name="NUM1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
        </block>
        <block type="operator_divide">
            <value name="NUM1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
        </block>
        <block type="operator_power">
            <value name="NUM1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
        </block>
        <block type="operator_mod">
            <value name="NUM1">
                <shadow type="text">
                    <field name="TEXT">5</field>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="text">
                    <field name="TEXT">2</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_random">
            <value name="FROM">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="TO">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_gt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_lt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_equals">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_and"/>
        <block type="operator_or"/>
        <block type="operator_not"/>
        ${blockSeparator}
        <block type="operator_string_of_integer">
            <value name="NUM">
                <shadow type="text">
                    <field name="TEXT">5</field>
                </shadow>
            </value>
        </block>
        <block type="operator_string_of_rational">
            <value name="NUM">
                <shadow type="text">
                    <field name="TEXT">5/2</field>
                </shadow>
            </value>
        </block>
        <block type="operator_string_of_float">
            <value name="NUM">
                <shadow type="text">
                    <field name="TEXT">5.2e-17f</field>
                </shadow>
            </value>
        </block>
        <block type="operator_join">
            <value name="STRING1">
                <shadow type="text">
                    <field name="TEXT">${apple} </field>
                </shadow>
            </value>
            <value name="STRING2">
                <shadow type="text">
                    <field name="TEXT">${banana}</field>
                </shadow>
            </value>
        </block>
        <block type="operator_letter_of">
            <value name="LETTER">
                <shadow type="math_whole_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="STRING">
                <shadow type="text">
                    <field name="TEXT">${apple}</field>
                </shadow>
            </value>
        </block>
        <block type="operator_length">
            <value name="STRING">
                <shadow type="text">
                    <field name="TEXT">${apple}</field>
                </shadow>
            </value>
        </block>
        <block type="operator_contains" id="operator_contains">
          <value name="STRING1">
            <shadow type="text">
              <field name="TEXT">${apple}</field>
            </shadow>
          </value>
          <value name="STRING2">
            <shadow type="text">
              <field name="TEXT">${letter}</field>
            </shadow>
          </value>
        </block>
        ${blockSeparator}
        <block type="operator_round">
            <value name="NUM">
                <shadow type="text">
                    <field name="TEXT">5/2</field>
                </shadow>
            </value>
        </block>
        <block type="operator_rational_of_float">
            <value name="NUM">
                <shadow type="text">
                    <field name="TEXT">1.3f</field>
                </shadow>
            </value>
        </block>
        <block type="operator_approximate_rational_as_float">
            <value name="NUM">
                <shadow type="text">
                    <field name="TEXT">1/3</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_mathop">
            <value name="NUM">
                <shadow type="text">
                    <field name="TEXT">5/2</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="esterel_at">
            <value name="LIST">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
            <value name="INDEX">
                <shadow type="text">
                    <field name="TEXT">0</field>
                </shadow>
            </value>
        </block>
        <block type="esterel_clone_of">
            <value name="INDEX">
                <shadow type="text">
                    <field name="TEXT">0</field>
                </shadow>
            </value>
            <value name="TARGET">
                <shadow type="esterel_target_menu"/>
            </value>
        </block>
        <block type="esterel_number_of_clones">
            <value name="TARGET">
                <shadow type="esterel_target_menu"/>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const myBlocks = function () {
    return `
    <category
        name="%{BKY_CATEGORY_MYBLOCKS}"
        id="myBlocks"
        colour="#FF6680"
        secondaryColour="#FF4D6A"
        custom="PROCEDURE">
    </category>
    `;
};

const xmlOpen = '<xml style="display: none">';
const xmlClose = '</xml>';

/**
 * @param {!boolean} isStage - Whether the toolbox is for a stage-type target.
 * @param {?string} targetId - The current editing target
 * @param {?string} categoriesXML - null for default toolbox, or an XML string with <category> elements.
 * @param {?string} costumeName - The name of the default selected costume dropdown.
 * @param {?string} backdropName - The name of the default selected backdrop dropdown.
 * @param {?string} soundName -  The name of the default selected sound dropdown.
 * @returns {string} - a ScratchBlocks-style XML document for the contents of the toolbox.
 */
const makeToolboxXML = function (isStage, targetId, categoriesXML,
    costumeName = '', backdropName = '', soundName = '') {
    const gap = [categorySeparator];

    costumeName = xmlEscape(costumeName);
    backdropName = xmlEscape(backdropName);
    soundName = xmlEscape(soundName);

    const everything = [
        xmlOpen,
        motion(isStage, targetId), gap,
        looks(isStage, targetId, costumeName, backdropName), gap,
        //sound(isStage, targetId, soundName), gap,
        events(isStage, targetId), gap,
        control(isStage, targetId), gap,
        sensing(isStage, targetId), gap,
        operators(isStage, targetId), gap,
        variables(isStage, targetId), gap,
        preemption(isStage, targetId)
    ];

    if (categoriesXML) {
        everything.push(gap, categoriesXML);
    }

    everything.push(xmlClose);
    return everything.join('\n');
};

export default makeToolboxXML;
